



























































































import Vue from 'vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DxColumn, DxDataGrid, DxScrolling } from 'devextreme-vue/data-grid'
import { FETCH_SEARCH_PRODUCT_LIST } from '@/store/action-types'
import { ProductSearchRequest } from '@/types/payload'
import { ProductSearchResponse } from '@/types/service-response'
import { ProductSearchResult } from '@/model/project/ProductSearchResult'

interface ComponentData {
  loading: boolean
  productList: ProductSearchResult[]

  schluessel: string
  bezeichnung: string
  lagercode: string
  gruppe: string
  barcode: string
  klProduktivNr: string
  verfuegbar: boolean
  nurBevorzugteLager: boolean
  nurAuslierfortSyzSRO: boolean
  gesperrteAusblenden: boolean
  verfuegbarReservationen: boolean
  verfuegbarBestellungen: boolean
  check1: boolean
  check2: boolean
  focusedRowKey: number
}

export default Vue.extend({
  name: 'ProductSearch',

  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    searchString: String,
    foundList: Array as () => ProductSearchResult[]
  },

  data (): ComponentData {
    return {
      loading: false,
      productList: [],

      schluessel: '',
      bezeichnung: '',
      lagercode: '',
      gruppe: '',
      barcode: '',
      klProduktivNr: '',
      verfuegbar: false,
      nurBevorzugteLager: false,
      nurAuslierfortSyzSRO: false,
      gesperrteAusblenden: false,
      verfuegbarReservationen: false,
      verfuegbarBestellungen: false,
      check1: true,
      check2: true,
      focusedRowKey: -1,
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onKeyDown (e: any): void {
      if(e.event.key === "Enter") {
        const foundProduct: ProductSearchResult | undefined = this.productList.find((item: ProductSearchResult) => item.produkt === this.focusedRowKey)
        if(foundProduct) {
          this.$emit('selectedProduct', foundProduct)
        }
      }
    },

    rowDblClick (event: any): void {
      this.$emit('selectedProduct', event.data)
    },

    onSearchButtonClick (): void {
      this.searchProduct()
    },

    onFocusedCellChanging (e: any) {
      e.isHighlighted = false
    },

    onFocusedRowChanged (e: any): void {
      this.focusedRowKey = e.component.option('focusedRowKey')
    },

    async searchProduct (): Promise<void> {
      const payload: ProductSearchRequest = {
        Schluessel: this.schluessel,
        Bezeichnung: this.bezeichnung,
        Lagercode: this.lagercode,
        Gruppe: this.gruppe,
        Barcode: this.barcode,
        KlProduktivNr: this.klProduktivNr,
        Verfuegbar: this.verfuegbar,
        NurBevorzugteLager: this.nurBevorzugteLager,
        NurAuslierfortSyzSRO: this.nurAuslierfortSyzSRO,
        GesperrteAusblenden: this.gesperrteAusblenden,
        VerfuegbarReservationen: this.verfuegbarReservationen,
        VerfuegbarBestellungen: this.verfuegbarBestellungen,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId
      }

      try {
        this.loading = true
        const response: ProductSearchResponse = await this.$store.dispatch(FETCH_SEARCH_PRODUCT_LIST, payload)
        if(!response.IsError && response.Results) {
          this.productList = ProductSearchResult.createFromResponse(response.Results)

          if(this.productList.length > 0) {
            //@ts-ignore
            this.$refs.dataGrid.instance.option("focusedRowIndex", -1);

            this.focusedRowKey = 0
            setTimeout(() => {
              //@ts-ignore
              this.$refs.dataGrid.instance.focus()
              this.focusedRowKey = this.productList[0].produkt
            }, 100)
          }
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    }
  },

  mounted (): void {
    this.schluessel = this.searchString ? this.searchString : ''
    this.productList = this.foundList ? this.foundList : []

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
